export function sliders() {
  if ($('.slideshow').length) {
    $('.slideshow').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      dots: true,
      autoplay: true,
      autoplaySpeed: 4000,
      appendArrows: '.slideshow__control',
      appendDots: '.slideshow__control'
    });
  }
  
  if ($('.brands-section .brands-section__list').length) {
    $('.brands-section .brands-section__list').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: true,
      rows: 0,
      appendArrows: '.brands-section .brands-section__control',
      appendDots: '.brands-section .brands-section__control',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
            arrows: false,
            dots: true
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            arrows: false,
            dots: true
          }
        }
      ]
    });
  }

  if ($('.about-section .brands-section__list').length) {
    $('.about-section .brands-section__list').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: true,
      appendArrows: '.about-section .brands-section__control',
      appendDots: '.about-section .brands-section__control',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
            arrows: false,
            dots: true
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            arrows: false,
            dots: true
          }
        }
      ]
    });
  }

  if ($('.about-slider').length) {
    $('.about-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      dots: true,
      appendArrows: '.about-slider-control',
      appendDots: '.about-slider-control'
    });
  }

  if ($('.product__slider').length) {
    $('.product__slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: false,
      accessibility: false,
      asNavFor: '.product__small-slider'
    });
  }

  if ($('.product__small-slider').length) {
    $('.product__small-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      accessibility: false,
      focusOnSelect: true,
      variableWidth: true,
      rows: 0,
      asNavFor: '.product__slider',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    });
  }

  const gallerySlider = function() {
    $('.popup-gallery__slider').not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      accessibility: false,
      asNavFor: '.popup-gallery__small-slider',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
          }
        }
      ]
    });

    $('.popup-gallery__small-slider').not('.slick-initialized').slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      arrows: false,
      accessibility: false,
      focusOnSelect: true,
      asNavFor: '.popup-gallery__slider',
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 7,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 6,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    });
  }
  gallerySlider()

  $('.tab-gallery, .popup-gallery__overlay').on('click', function () {
    $('.popup-gallery').toggle();
    $('.popup-gallery__slider').slick('unslick');
    $('.popup-gallery__small-slider').slick('unslick');
    // $('.popup-gallery__slide').fancybox();
    gallerySlider();
  });

  let centerMode = $('.spare-tabs__list li').length > 7 ? true : false;

  if ($('.spare-tabs__list').length) {
    $('.spare-tabs__list').slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      centerMode: centerMode,
      centerPadding: '0',
      asNavFor: '.spare-file',
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            variableWidth: true
          }
        }
      ]
    });
  }

  if ($('.spare-file').length) {
    $('.spare-file').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      touchMove: false,
      draggable: false,
      arrows: false,
      adaptiveHeight: true
    });
  }

  if ($('.certificates__slider').length) {
    $('.certificates__slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: true,
      appendArrows: '.certificates__control',
      appendDots: '.certificates__control',
      responsive: [
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 2,
            dots: false,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots: false,
          }
        }
      ]
    });
  }

  if ($('.honors__slider').length) {
    $('.honors__slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      appendArrows: '.certificates__control',
      appendDots: '.certificates__control',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  }

  if ($(window).width() <= 767 && $('.brands__wrap .brands--slider').length) {
    $('.brands__wrap .brands--slider').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      appendDots: '.brands__wrap .brands-section__control',
      responsive: [
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  }

  $('.product__small-slider').each(function destroySlider() {
    if ($(this).find('.slick-slide').length <= 4) {
      $(this).addClass('no-slider');
    }
  })

  $('.news-inner__image-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 0,
    fade: true,
    arrows: true,
    prevArrow: '<div class="news-inner__btn news-inner__prev-btn"><svg xmlns="http://www.w3.org/2000/svg" width="21.75" height="40.937" viewBox="0 0 21.75 40.937"><path d="M198.656,500.682l18.569-18.5a1.151,1.151,0,0,0,0-1.639,1.163,1.163,0,0,0-1.646,0l-19.4,19.322a1.152,1.152,0,0,0,0,1.64l19.4,19.314a1.174,1.174,0,0,0,.819.343,1.139,1.139,0,0,0,.818-0.343,1.152,1.152,0,0,0,0-1.64Z" transform="translate(-195.844 -480.219)"/></svg></div>', 
    nextArrow: '<div class="news-inner__btn news-inner__next-btn"><svg xmlns="http://www.w3.org/2000/svg" width="21.75" height="40.937" viewBox="0 0 21.75 40.937"><path d="M1721.34,500.682l-18.57-18.5a1.163,1.163,0,1,1,1.65-1.639l19.4,19.322a1.165,1.165,0,0,1,0,1.64l-19.4,19.314a1.16,1.16,0,1,1-1.64-1.64Z" transform="translate(-1702.44 -480.219)"/></svg></div>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          dots: true
        }
      }
    ]
  });
}



// WEBPACK FOOTER //
// app/scripts/components/sliders.js